export default __webpack_public_path__ + "static/media/Erica_Pagnoni_Waves_of_magic_40_x_60_cm.d38af059.jpg";